module.exports = __webpack_public_path__ + "img/media-14.ab609d12.png";